import { SelectInput, TextInput } from 'react-admin';
import FileManagerModalInput from '../FileManagerModalInput';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayENewsletter = ({ index, source, }: { source: string, index: number }) => {
  return (
    <ArrayForm source={source} grid={0}>
      <BoundedInput source={`year_group_en`} input={<TextInput source="dummy" fullWidth helperText={false} />} />
      <BoundedInput source={`year_group_tc`} input={<TextInput source="dummy" fullWidth helperText={false} />} />
      <BoundedInput source={`year_group_sc`} input={<TextInput source="dummy" fullWidth helperText={false} />} />
      <ArrayForm source={`list`} grid={0} simpleFormIteratorProps={{
        sx: {
          '& .RaSimpleFormIterator-form': {
            display: 'grid',
            gap: '0px',
            columnGap: '10px',
            gridTemplateAreas: `
          'title_en title_en title_tc title_tc title_sc title_sc'
          'cover_image cover_image cover_image cover_image cover_image cover_image'
          'click_action click_action click_action link link link'`
          }
        }
      }}>
        <BoundedInput source={`title_en`} input={<TextInput source="dummy" />} />
        <BoundedInput source={`title_tc`} input={<TextInput source="dummy" />} />
        <BoundedInput source={`title_sc`} input={<TextInput source="dummy" />} />
        <BoundedInput source={`cover_image`} input={<FileManagerModalInput source="dummy" hideLabel={true} />} />
        <BoundedInput source={`click_action`} input={<SelectInput
          source="dummy"
          choices={[
            { id: 'open_pdf', name: 'Open PDF' },
            { id: 'open_link', name: 'Open Link' },
          ]} />} />
        <BoundedInput source={`link`} input={<TextInput source="dummy" />} />
      </ArrayForm>
    </ArrayForm>
  )
}

export default ArrayENewsletter;